export default "__VITE_ASSET__CZrqM$Ei__"